export const ADD_COLLECTION_DATA = 'ADD_COLLECTION_DATA'
export const INITIAL_STATE = 'INITIAL_STATE'
